import {
    Radio, RadioGroup as MuiRadioGroup,
    RadioGroupProps,
    CircularProgress, TextField, FormControl, FormLabel, FormControlLabel,
    FormHelperText
} from "@mui/material";
import { useField } from "@unform/core";
import { useEffect, useMemo, useState } from "react";
import { useDebounce } from "../../hooks";
import { CidadeService } from "../../services/api/cidade/CidadeService";
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";

type TOptions = {
    codigo: number;
    label: string;
}

type IRadioGroupProps = RadioGroupProps & {
    isExternalLoading?: boolean;
    items: TOptions[];
    name: string;
    label: string;
}

export const RadioGroup: React.FC<IRadioGroupProps> = ({ isExternalLoading = false, items, name, label, ...rest }) => {
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name)

    const [value, setValue] = useState(defaultValue || "");
    useEffect(() => {
        registerField({
            name: fieldName,
            getValue: () => value,
            setValue: (_, newSelectdId) => setValue(newSelectdId),
        })
    }, [registerField, fieldName, value])

    const handleChange = (event: { target: { name: string; value: any; }; }) => {
        setValue(Number(event.target.value));
    }

    return (
        <FormControl disabled={isExternalLoading}>
            <FormLabel>{label}</FormLabel>
            <MuiRadioGroup
                {...rest}
                row
                defaultValue={defaultValue}
                onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
                name={fieldName}
                value={value}
                sx={{
                    '& .MuiFormControlLabel-label': { 
                        fontSize: UtilidadeService.isMobile() ? 12 : 14 
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: UtilidadeService.isMobile() ? 20 : 20,
                    },
                }}

                onChange={(e) => { handleChange(e); error && clearError(); rest.onChange?.(e, "") }}>
                {
                    items.map(item => (<FormControlLabel style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }} key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                }
            </MuiRadioGroup>
            <FormHelperText sx={{ color: "red" }}>{error}</FormHelperText>
        </FormControl >
    );
};